
import {
  Button,
  Typography,
  DialogActions,
  Divider,
  MenuItem,
  Dialog,
  Stack,
} from '@mui/material';
// @types
//import { NewPostFormValues } from '../../../@types/blog';
import { Role } from 'src/@types/lms/roles';
// components
import { RHFSelect } from 'src/components/hook-form';
import { useState } from 'react';

// ----------------------------------------------------------------------

type Props = {
  values: Role[];
  isOpen: boolean;
  onClose: VoidFunction;
  onSubmitRole(role: Role): Promise<void>;
};

const defaultValues = {
  id: '',
  name: '',
  description: '',
  enabled: true,
};

export default function SelectRoleDialog({ values, isOpen, onClose, onSubmitRole }: Props) {
  const [roleSelected, setSelectedRole] = useState('');

  function selectRole() {
    if (roleSelected !== '') {
      let value = defaultValues;
      value.name = roleSelected;
      setSelectedRole('');
      onSubmitRole(value);
    }
  }

  return (
    <Dialog
      open={isOpen}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
          onClose();
        }
      }}
      //disableEscapeKeyDown
      fullWidth
      maxWidth="md"
    >
      <DialogActions sx={{ py: 2, px: 3 }}>
        <Typography variant="subtitle1" sx={{ flexGrow: 1 }}>
          Select Role to Log In as
        </Typography>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>

      <Stack alignItems="center" sx={{ mt: 3, mb: 3 }} spacing={2}>
        <RHFSelect
          id="roleSelect"
          name="name"
          label="Role"
          sx={{ width: '60%' }}
          onChange={(event) => setSelectedRole(event.target.value)}
          value={roleSelected}
          InputLabelProps={{ shrink: true }}
          SelectProps={{ native: false, sx: { textTransform: 'capitalize' } }}
        >
          <MenuItem
            key=""
            value=""
            selected={true}
            sx={{
              mx: 1,
              borderRadius: 0.75,
              typography: 'body2',
              fontStyle: 'italic',
              color: 'text.secondary',
            }}
          >
            Select Role
          </MenuItem>
          <Divider />
          {values.map((option) => (
            <MenuItem
              key={option.name}
              value={option.name}
              sx={{
                mx: 1,
                my: 0.5,
                borderRadius: 0.75,
                typography: 'body2',
                textTransform: 'capitalize',
              }}
            >
              {option.name}
            </MenuItem>
          ))}
        </RHFSelect>
        <Button onClick={selectRole} sx={{ width: '20%' }} variant="contained">
          Select
        </Button>
      </Stack>
    </Dialog>
  );
}

// ----------------------------------------------------------------------
